import { useAuth } from '../lib/AuthContext';
import { useI18n } from '../lib/i18n';
import { useState } from 'react';

export default function Referrals() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const link = `https://app.finart.rs/?ref=${user?.id?.slice(0, 8) || ''}`;

  const copy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <h1 style={styles.heading}>{t('referralsHeading')}</h1>
      <p style={styles.sub}>{t('referralsSub')}</p>

      <div style={styles.card}>
        <div style={styles.label}>{t('referralLinkLabel')}</div>
        <div style={styles.linkRow}>
          <input readOnly value={link} style={styles.linkInput} />
          <button onClick={copy} style={styles.copyBtn}>{copied ? t('copiedLabel') : t('copyBtn')}</button>
        </div>
      </div>

      <div style={styles.note}>{t('referralsNote')}</div>
    </div>
  );
}

const styles = {
  heading: { fontSize: 22, marginBottom: 8 },
  sub: { fontSize: 13, color: 'var(--ink-500)', marginBottom: 18 },
  card: { background: 'var(--surface)', borderRadius: 10, padding: 18, border: '1px solid var(--line)', marginBottom: 16 },
  label: { fontSize: 12, color: 'var(--ink-500)', marginBottom: 8 },
  linkRow: { display: 'flex', gap: 8 },
  linkInput: { flex: 1, border: '1.5px solid var(--line)', borderRadius: 10, padding: '10px 12px', fontSize: 13, color: 'var(--ink-700)', background: 'var(--paper)' },
  copyBtn: { background: 'var(--teal-800)', color: '#fff', border: 'none', borderRadius: 10, padding: '0 16px', fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap' },
  note: { fontSize: 12, color: 'var(--ink-500)' },
};
